import { useCheckoutStepsStyles } from '../../../styles/organisms/checkout-steps.styles';
import { PatientSteps } from '../../../data';
import { PatientStepsProps } from './patient-steps.props';

export const PatientStepsOrganism = (props: PatientStepsProps) => {
  const classes = useCheckoutStepsStyles();
  return (
    <div
      className={`${classes.CheckoutStepsContent} bg-waldo-blue bg-opacity-10 py-4 px-8 md:w-11/12 mx-auto block lg:hidden`}
    >
      <ul className="flex flex-row ">
        {PatientSteps.map((steps, index) => (
          <li className="list-none text-waldo-blue" key={index}>
            {props.active === steps ? (
              <div className="opacity-100 font-medium">
                {steps}
                <span className="arrow inline-block mx-3"></span>
              </div>
            ) : (
              <div className="opacity-50 font-normal">
                {steps}
                <span className="arrow inline-block mx-3"></span>
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};
